import React, { useState, useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Infopiramide } from '../../../services/perfiles/conponentesServices';
import { Select } from 'antd';
import './tablaPi.css';

const { Option } = Select;

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const PiramideP = ({ municipioId }) => {
    const [rawData, setRawData] = useState([]);
    const [filteredData, setFilteredData] = useState(null);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [years, setYears] = useState([]);
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear().toString());
    const [selectedAgeRange, setSelectedAgeRange] = useState('all');

    const fetchData = async () => {
        setLoading(true);
        setError('');
        try {
            const response = await Infopiramide(municipioId);
            if (response && response.status === 200) {
                const fetchedData = response.data;
                const uniqueYears = [...new Set(fetchedData.map(item => item.vigencia))];
                setYears(uniqueYears);
                setRawData(fetchedData);
                filterData(fetchedData, selectedYear, selectedAgeRange);
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            setError('Error loading data');
        } finally {
            setLoading(false);
        }
    };

    const parseAgeRange = (range) => {
        if (range === "+100 años" || range === "100+") {
            return 101; // Higher than any other range
        }
        const [start] = range.split('-').map(Number);
        return start;
    };

    const filterData = (fetchedData, year, ageRange) => {
        const filtered = fetchedData.filter(item => item.vigencia === year && (ageRange === 'all' || item.rango === ageRange));

        // Sort data by age range
        const sortedData = filtered.sort((a, b) => parseAgeRange(a.rango) - parseAgeRange(b.rango));

        const chartData = {
            labels: sortedData.map(item => item.rango),
            datasets: [
                {
                    label: 'Hombres',
                    backgroundColor: '#42A5F5',
                    data: sortedData.map(item => -parseFloat(item.porc_hombre)), // negative for left side of pyramid
                },
                {
                    label: 'Mujeres',
                    backgroundColor: '#EC407A',
                    data: sortedData.map(item => parseFloat(item.porc_mujer)), // positive for right side of pyramid
                },
            ],
        };

        setFilteredData(chartData);
    };

    useEffect(() => {
        if (municipioId) {
          fetchData();  
        }
        
    }, [municipioId]);

    useEffect(() => {
        if (rawData.length) {
            filterData(rawData, selectedYear, selectedAgeRange);
        }
    }, [rawData, selectedYear, selectedAgeRange]);

    const handleYearChange = (value) => {
        setSelectedYear(value);
    };

    const handleAgeRangeChange = (value) => {
        setSelectedAgeRange(value);
    };

    return (
        <div >
            <h3>1.1 Pirámides poblacionales por edades</h3>
            <div className="filters">
                <Select defaultValue={selectedYear} onChange={handleYearChange} style={{ width: 120, marginRight: 10 }}>
                    {years.map(year => (
                        <Option key={year} value={year}>{year}</Option>
                    ))}
                </Select>
                <Select defaultValue="all" onChange={handleAgeRangeChange} style={{ width: 120 }}>
                    <Option value="all">All Ages</Option>
                    {rawData.length > 0 && [...new Set(rawData.map(item => item.rango))]
                        .sort((a, b) => parseAgeRange(a) - parseAgeRange(b))
                        .map(ageRange => (
                            <Option key={ageRange} value={ageRange}>{ageRange}</Option>
                        ))}
                </Select>
            </div>
            {loading ? (
                <p>Loading...</p>
            ) : error ? (
                <p>{error}</p>
            ) : filteredData ? (
                <div className="chart-container" style={{ position: 'relative', height: '500px' }}>
                    <Bar
                        data={filteredData}
                        options={{
                            indexAxis: 'y',
                            scales: {
                                x: {
                                    stacked: true,
                                    ticks: {
                                        callback: value => Math.abs(value), // show absolute values on x-axis
                                    },
                                },
                                y: {
                                    stacked: true,
                                },
                            },
                        }}
                    />
                </div>
            ) : (
                <p>No data available</p>
            )}
        </div>
    );
};

export default PiramideP;
